var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-2"},[(_vm.isApplePaySupported)?_c('div',{attrs:{"id":"apple-pay-button"},on:{"click":_vm.initializeApplePay}}):_c('p',[_vm._v(_vm._s(_vm.$t('Apple Pay is not supported on this device/browser.')))])])}
var staticRenderFns = []

export { render, staticRenderFns }